import { BlogArticle } from "../../../../components/pages/blog/BlogArticle";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  fetchAllBlogs,
  fetchBlog,
  filterBlogsByAuthor,
} from "../../../../services/fetch-data/blogUtil";
import { BlogData } from "../../../../hooks/react-query/useBlogList";
import { MyHead } from "../../../../components/pages/MyHead";
import { Fragment, useEffect, useState } from "react";
import { NotFound } from "../../../../components/pages/404/NotFound";
import { fetchAllSpecialists } from "../../../../services/fetch-data/specialistUtil";
import { BlogList } from "../../../../components/pages/blog/BlogList";
import { PageHeader } from "../../../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../../../components/UI/my-h1/MyH1";
import { isPhone } from "../../../../constants/env";
import { Text } from "@mantine/core";
import { useColors } from "../../../../hooks/colors/useColors";
import { useTranslation } from "next-i18next";
import { useSpecialistList } from "../../../../hooks/react-query/useSpecialistList";
import { useRouter } from "next/router";
import { isMobile } from "react-device-detect";

// @ts-ignore
export async function getStaticProps(context: any) {
  const allBlogs = await fetchAllBlogs(context.locale);
  let authorBlogs: Record<string, BlogData> = {};
  if (allBlogs) {
    authorBlogs = filterBlogsByAuthor(allBlogs, context.params.author);
  }

  return {
    props: {
      ...(await serverSideTranslations(context.locale, ["common"])),
      blogs: authorBlogs,
    },
    revalidate: 60,
  };
}

/*
Prefetch all author blogs on build
 */
export async function getStaticPaths() {
  const specialists = await fetchAllSpecialists();
  const paths: any[] = [];
  if (specialists) {
    Object.keys(specialists).map((slug) => {
      paths.push({ params: { author: slug } });
    });
  }
  return {
    paths: paths,
    fallback: "blocking", //indicates the type of fallback
  };
}

function AuthorBlogList(params: { blogs: Record<string, BlogData> }) {
  const { blogs } = params;
  const { i18n } = useTranslation("common");
  const [authorName, setAuthor] = useState<string>("");
  const { specialists } = useSpecialistList();
  const router = useRouter();
  const { author } = router.query;

  useEffect(() => {
    if (specialists && Object.keys(specialists).length > 0) {
      {
        Object.keys(specialists)
            .sort((a, b) => a.localeCompare(b))
            .map((key, index) => {
              if (key === author) {
                const specialist = specialists[key];
                setAuthor(specialist.name);
              }
            });
      }
    }
  }, [author, specialists]);

  return (
      <Fragment>
        <PageHeader>
          <div className="text-center">
            <MyH1
                size={isMobile ? "1.8rem" : "2.6rem"}
                className="text-center"
                color="white"
            >
              {`${authorName}, ${i18n.t("blog.name")}`}
            </MyH1>
            <Text className="!text-white text-[22px] font-bold">
              {i18n.t("useful-info")}
            </Text>
          </div>
        </PageHeader>
        <BlogList authorBlogs={blogs} />
      </Fragment>
  );
}

export default AuthorBlogList;

// import { serverSideTranslations } from "next-i18next/serverSideTranslations";
// import {
//   filterBlogsByAuthor,
//   getAllAuthors,
// } from "../../../../services/fetch-data/blogUtil";
// import { Fragment, useEffect, useState } from "react";
// import { BlogList } from "../../../../components/pages/blog/BlogList";
// import { PageHeader } from "../../../../components/pages/page-header/PageHeader";
// import { MyH1 } from "../../../../components/UI/my-h1/MyH1";
// import { Text } from "@mantine/core";
// import { useTranslation } from "next-i18next";
// import { isMobile } from "react-device-detect";
// import { MyHead } from "../../../../components/pages/MyHead";
// import { Post } from "../../../../types/graphql";
//
// // @ts-ignore
// export async function getStaticProps(context: any) {
//   const allBlogs = await filterBlogsByAuthor(
//     context.locale,
//     context.params.author
//   );
//   return {
//     props: {
//       ...(await serverSideTranslations(context.locale, ["common"])),
//       blogs:
//         allBlogs.data.users.edges.length > 0
//           ? allBlogs.data.users.edges[0].node!.posts!.nodes
//           : null,
//       author: context.params.author,
//     },
//     revalidate: 60,
//   };
// }
//
// /*
// Prefetch all author blogs on build
//  */
// export async function getStaticPaths() {
//   const authors = await getAllAuthors();
//   const paths: any[] = [];
//   if (authors) {
//     authors.data.users.edges.map((user) => {
//       paths.push({ params: { author: user.node.slug } });
//     });
//   }
//
//   return {
//     paths: paths,
//     fallback: "blocking", //indicates the type of fallback
//   };
// }
//
// function BlogEntry(params: { blogs: Post[] }) {
//   const { blogs } = params;
//   const { i18n } = useTranslation("common");
//   const [authorName, setAuthor] = useState<string>("");
//
//   useEffect(() => {
//     if (blogs.length > 0) {
//       const blog = blogs[0];
//       setAuthor(blog.author?.node.name!);
//     }
//   }, [blogs]);
//
//   return (
//     <Fragment>
//       <MyHead
//         title={`${i18n.t("our-blog")} - ${authorName}`}
//         description={
//           authorName
//             ? `${authorName} - ${i18n.t("useful-info")}`
//             : i18n.t("useful-info")
//         }
//       />
//       <PageHeader>
//         <div className="text-center">
//           <MyH1
//             size={isMobile ? "1.8rem" : "2.6rem"}
//             className="text-center"
//             color="white"
//           >
//             {`${authorName}, ${i18n.t("blog.name")}`}
//           </MyH1>
//           <Text className="!text-white text-[22px] font-bold">
//             {i18n.t("useful-info")}
//           </Text>
//         </div>
//       </PageHeader>
//       <BlogList prefetchedPosts={blogs} />
//     </Fragment>
//   );
// }
//
// export default BlogEntry;
